"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _chunkFU6IGQCVjs = require('./chunk-FU6IGQCV.js');var _chunk52DAEPPLjs = require('./chunk-52DAEPPL.js');var _react = require('react'); var _react2 = _interopRequireDefault(_react);var _styled = require('@emotion/styled'); var _styled2 = _interopRequireDefault(_styled);var _jsxruntime = require('react/jsx-runtime');var u=_styled2.default.div`
  min-height: ${t=>t.theme.measurements.spacing(24)};
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;
  text-align: left;
  gap: ${t=>t.theme.measurements.spacing(12)};

  &::-webkit-scrollbar {
    display: none;
  }
`;function d({children:t,className:i}){let a=_react.useRef.call(void 0, null),l=_react2.default.Children.map(t,(e,n)=>e.type===_chunkFU6IGQCVjs.a?_react2.default.cloneElement(e,{index:n}):e),c=_chunk52DAEPPLjs.b.call(void 0, ).tabsInfo.selectedTabIndex;return _react.useEffect.call(void 0, ()=>{let e=a.current;if(e){let n=e.querySelector(".activetab");n&&(e.scrollLeft=n.offsetLeft-20)}},[c]),_jsxruntime.jsx.call(void 0, u,{ref:a,className:`${i||""} aquilla-tablist tablist`,children:l})}var v=d;exports.a = v;
